import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData, getList } from '../../helpers/fackBackend_Helper';


function* getAllDAilyAddonPriceMappingDataResponse() {
    try {
        const response = yield call(getList, '/dailyAddonPriceMapping');
        if (response.Status) {
            yield put(actions.getAllDailyAddonPriceMappingDataSuccess(response.Data));
        } else {
            yield put(actions.getAllDailyAddonPriceMappingDataFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.getAllDailyAddonPriceMappingDataFailed(error.Message));
    }
}

function* updateDailyAddonPriceMappingDataResponse({ data }) {
    try {
        const response = yield call(addData, '/dailyAddonPriceMapping', data);
        if (response.Status) {
            const responseList = yield call(getList, '/dailyAddonPriceMapping');
            if (responseList.Status) {
                yield put(actions.updateDailyAddonPriceMappingDataSuccess(response.Data[0].Message, responseList.Data));
            }
            else {
                yield put(actions.getAddonWiseMappingFailed(response.Data[0].Message));
            }

        } else {
            yield put(actions.updateDailyAddonPriceMappingDataFailed(response.Data[0].Message));
        }
    } catch (error) {
        yield put(actions.updateDailyAddonPriceMappingDataFailed(error.Message));
    }
}

function* updateDailyAddonMappingByDealerIDResponse({ payload: { dealerId, data } }) {
    try {
        const response = yield call(addData, '/updateDailyAddonPriceMapping/' + dealerId, data);
        if (response.Status) {
            yield put(actions.updateDailyAddonMappingDataByDealerIdSuccess(response.Message));
            yield put(actions.getAllDailyAddonPriceMappingData());
        } else {
            yield put(actions.updateDailyAddonMappingDataByDealerIdFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.updateDailyAddonMappingDataByDealerIdFailed(error.Message));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA, getAllDAilyAddonPriceMappingDataResponse)]);
    yield all([takeEvery(actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA, updateDailyAddonPriceMappingDataResponse)]);
    yield all([takeEvery(actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID, updateDailyAddonMappingByDealerIDResponse)]);
}